import { AppDispatchType, RootStateType } from 'store'
import { getLocations } from 'features/Location/services/location'
import type { GetLocationListRequestType } from 'features/Location/@types/location'
import { callErrorMsg } from 'helpers/errorMsg'
import { getAssetInventoryListV2 } from 'features/AssetManagement/services/supplyOrder'
import {
  HandheldMonitoringUnregisterRequestType,
  registrationHandheldMonitoring,
} from 'features/AssetManagement/services/handheldMonitoring'
import { toastSuccess } from 'utils/toast'
import {
  setLocationList,
  setHandheldResponseData,
  setModalUnregister,
  setIsLoading,
  setSelectedItemListData,
  resetModalUnregister,
} from './slice'

export const actGetLocations =
  (params?: GetLocationListRequestType) => async (dispatch: AppDispatchType) => {
    try {
      const { data } = await getLocations(params)
      dispatch(setLocationList(data.content))
    } catch (err) {
      callErrorMsg(err)
    }
  }

const HANDHELD_DEVICE_CATEGORY = 144
export const actGetHandheldMonitoringList =
  () => async (dispatch: AppDispatchType, getState: () => RootStateType) => {
    const { filter } = getState().handheldMonitoring
    dispatch(setIsLoading(true))

    try {
      const { data } = await getAssetInventoryListV2({
        page_index: filter.pageIndex,
        page_size: filter.pageSize,
        status: 'used',
        asset_category_ids: [HANDHELD_DEVICE_CATEGORY],
        ...(filter.selectedLocation && { origin_id: String(filter.selectedLocation.location_id) }),
        ...(filter.searchValue && { codes: filter.searchValue }),
      })
      dispatch(setHandheldResponseData(data))
    } catch (err) {
      callErrorMsg(err)
    } finally {
      dispatch(setIsLoading(false))
    }
  }

export const actUnregisterHandheldMonitoring =
  () => async (dispatch: AppDispatchType, getState: () => RootStateType) => {
    const { modalUnregister, selectedItemList } = getState().handheldMonitoring
    const { itemData } = modalUnregister

    if (!itemData) return
    dispatch(
      setModalUnregister({
        isSubmittingData: true,
      }),
    )

    let listDataToSubmit: HandheldMonitoringUnregisterRequestType['data'] = []
    if (modalUnregister.type === 'single') {
      listDataToSubmit = [
        {
          asset_code: modalUnregister.itemData.code,
          status: 'available',
          category_id: HANDHELD_DEVICE_CATEGORY,
        },
      ]
    } else {
      listDataToSubmit = selectedItemList.map((code) => ({
        asset_code: code,
        status: 'available',
        category_id: HANDHELD_DEVICE_CATEGORY,
      }))
    }

    try {
      const { data } = await registrationHandheldMonitoring({
        data: listDataToSubmit,
      })

      toastSuccess(data.message)

      if (modalUnregister.type === 'multiple') {
        dispatch(setSelectedItemListData([]))
      }
      dispatch(resetModalUnregister())
      dispatch(actGetHandheldMonitoringList())
    } catch (err) {
      callErrorMsg(err)
    }
  }
